import Q from 'q';

import user from 'js/lib/user';

import courseViewGradePromise from 'pages/open-course/common/promises/courseViewGrade';

export const loadCourseViewGrade = (actionContext: $TSFixMe, { courseId }: $TSFixMe) => {
  if (actionContext.getStore('CourseViewGradeStore').hasLoaded()) {
    return Q();
  }

  return courseViewGradePromise(`${user.get().id}~${courseId}`, true)
    .then((rawCourseViewGrade: $TSFixMe) => {
      actionContext.dispatch('LOAD_COURSE_VIEW_GRADE', rawCourseViewGrade);
    })
    .fail((error: $TSFixMe) => {
      actionContext.dispatch('ERROR_LOADING_COURSE_VIEW_GRADE', { error, courseId });
    });
};

export const refreshCourseViewGrade = (actionContext: $TSFixMe, { courseId }: $TSFixMe) => {
  return courseViewGradePromise(`${user.get().id}~${courseId}`, true).then((courseViewGrade: $TSFixMe) => {
    actionContext.dispatch('LOAD_COURSE_VIEW_GRADE', courseViewGrade);
  });
};
